<template>
	<div 
		:class="_class"
		@click="$emit('click', $event)"
		@mouseenter="$emit('mouseenter', $event)"
		@mouseleave="$emit('mouseleave', $event)">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'type-grid',
		props: {
			row: {
				type: [String, Number],
				default: 1,
				validator: value => 0 < Number(value)
			},
			nowrap: {
				type: Boolean,
				default: false
			},
			margin: {
				type: Boolean,
				default: false
			},
			padding: {
				type: Boolean,
				default: false
			},
			center: {
				type: Boolean,
				default: false
			},
			middle: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			_class() {
				let _class = 'type-grid';
				let row = Number(this.row);
				if ([1, 2, 3, 4, 23, 34].includes(row) === false && 4 < row) {
					row = 4;
				}
				if (this.center) {
					_class = 'type-grid-center';
				}
				if (this.middle) {
					_class = 'type-grid-middle';
				}
				if (this.margin) {
					if (this.nowrap) {
						return `${_class} grid-row${row}-margin-nowrap`;
					}
					return `${_class} grid-row${row}-margin`;
				}
				if (this.padding) {
					if (this.nowrap) {
						return `${_class} grid-row${row}-padding-nowrap`;
					}
					return `${_class} grid-row${row}-padding`;
				}
				if (this.nowrap) {
					return `${_class} grid-row${row}-nowrap`;
				}
				return `${_class} grid-row${row}`;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-grid{
		display: inline-block;
	}
	.type-grid-center{
		display: inline-flex;
		flex-wrap: wrap;
		justify-content: center;
	}
	.type-grid-middle{
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}
	
	@media screen and (min-width: 1280px){
		.grid-row1{
			width: 100%;
		}
		.grid-row2{
			width: 50%;
		}
		.grid-row3{
			width: calc(100% / 3);
		}
		.grid-row4{
			width: 25%;
		}
		.grid-row23{
			width: calc(200% / 3);
		}
		.grid-row34{
			width: calc(75%);
		}
		.grid-row1-margin{
			margin: 15px;
			width: calc(100% - 30px);
		}
		.grid-row2-margin{
			margin: 15px;
			width: calc(50% - 30px);
		}
		.grid-row3-margin{
			margin: 15px;
			width: calc(100% / 3 - 30px);
		}
		.grid-row4-margin{
			margin: 15px;
			width: calc(25% - 30px);
		}
		.grid-row23-margin{
			margin: 15px;
			width: calc(200% / 3 - 30px);
		}
		.grid-row34-margin{
			margin: 15px;
			width: calc(75% - 30px);
		}
		.grid-row1-padding{
			padding: 15px;
			width: calc(100% - 30px);
		}
		.grid-row2-padding{
			padding: 15px;
			width: calc(50% - 30px);
		}
		.grid-row3-padding{
			padding: 15px;
			width: calc(100% / 3 - 30px);
		}
		.grid-row4-padding{
			padding: 15px;
			width: calc(25% - 30px);
		}
		.grid-row23-padding{
			padding: 15px;
			width: calc(200% / 3 - 30px);
		}
		.grid-row34-padding{
			padding: 15px;
			width: calc(75% - 30px);
		}
	}
	@media screen and (min-width: 1080px) and (max-width: 1279px){
		.grid-row1{
			width: 100%;
		}
		.grid-row2{
			width: 50%;
		}
		.grid-row3, .grid-row4{
			width: calc(100% / 3);
		}
		.grid-row23, .grid-row34{
			width: calc(200% / 3);
		}
		.grid-row1-margin{
			margin: 15px;
			width: calc(100% - 30px);
		}
		.grid-row2-margin{
			margin: 15px;
			width: calc(50% - 30px);
		}
		.grid-row3-margin, .grid-row4-margin{
			margin: 15px;
			width: calc(100% / 3 - 30px);
		}
		.grid-row23-margin, .grid-row34-margin{
			padding: 15px;
			width: calc(200% / 3 - 30px);
		}
		.grid-row1-padding{
			padding: 15px;
			width: calc(100% - 30px);
		}
		.grid-row2-padding{
			padding: 15px;
			width: calc(50% - 30px);
		}
		.grid-row3-padding, .grid-row4-padding{
			padding: 15px;
			width: calc(100% / 3 - 30px);
		}
		.grid-row23-padding, .grid-row34-padding{
			padding: 15px;
			width: calc(200% / 3 - 30px);
		}
	}
	@media screen and (min-width: 720px) and (max-width: 1079px){
		.grid-row1{
			width: 100%;
		}
		.grid-row2, .grid-row3, .grid-row4, .grid-row23, .grid-row34{
			width: 50%;
		}
		.grid-row1-margin{
			margin: 15px;
			width: calc(100% - 30px);
		}
		.grid-row2-margin, .grid-row3-margin, .grid-row4-margin, .grid-row23-margin, .grid-row34-margin{
			margin: 15px;
			width: calc(50% - 30px);
		}
		.grid-row1-padding{
			padding: 15px;
			width: calc(100% - 30px);
		}
		.grid-row2-padding, .grid-row3-padding, .grid-row4-padding, .grid-row23-padding, .grid-row34-padding{
			padding: 15px;
			width: calc(50% - 30px);
		}
	}
	@media screen and (max-width: 719px){
		.grid-row1, .grid-row2, .grid-row3, .grid-row4, .grid-row23, .grid-row34{
			width: 100%;
		}
		.grid-row1-margin, .grid-row2-margin, .grid-row3-margin, .grid-row4-margin, .grid-row23-margin, .grid-row34-margin{
			margin: 15px 0;
			width: 100%;
		}
		.grid-row1-padding, .grid-row2-padding, .grid-row3-padding, .grid-row4-padding, .grid-row23-padding, .grid-row34-padding{
			padding: 15px;
			width: calc(100% - 30px);
		}
	}
	
	@media screen and (min-width: 720px){
		.grid-row1-nowrap{
			width: 100%;
		}
		.grid-row1-margin-nowrap{
			margin: 15px;
			width: calc(100% - 30px);
		}
		.grid-row1-padding-nowrap{
			padding: 15px;
			width: calc(100% - 30px);
		}
		.grid-row2-nowrap{
			width: 50%;
		}
		.grid-row2-margin-nowrap{
			margin: 15px;
			width: calc(50% - 30px);
		}
		.grid-row2-padding-nowrap{
			padding: 15px;
			width: calc(50% - 30px);
		}
		.grid-row3-nowrap{
			width: calc(100% / 3);
		}
		.grid-row3-margin-nowrap{
			margin: 15px;
			width: calc(100% / 3 - 30px);
		}
		.grid-row3-padding-nowrap{
			padding: 15px;
			width: calc(100% / 3 - 30px);
		}
		.grid-row4-nowrap{
			width: 25%;
		}
		.grid-row4-margin-nowrap{
			margin: 15px;
			width: calc(25% - 30px);
		}
		.grid-row4-padding-nowrap{
			padding: 15px;
			width: calc(25% - 30px);
		}
		.grid-row23-nowrap{
			width: calc(200% / 3);
		}
		.grid-row23-margin-nowrap{
			margin: 15px;
			width: calc(200% / 3 - 30px);
		}
		.grid-row23-padding-nowrap{
			padding: 15px;
			width: calc(200% / 3 - 30px);
		}
		.grid-row34-nowrap{
			width: 75%;
		}
		.grid-row34-margin-nowrap{
			margin: 15px;
			width: calc(75% - 30px);
		}
		.grid-row34-padding-nowrap{
			padding: 15px;
			width: calc(75% - 30px);
		}
	}
	@media screen and (max-width: 719px){
		.grid-row1-nowrap, .grid-row2-nowrap, .grid-row3-nowrap, .grid-row4-nowrap, .grid-row23-nowrap, .grid-row34-nowrap{
			width: 100%;
		}
		.grid-row1-margin-nowrap, .grid-row2-margin-nowrap, .grid-row3-margin-nowrap, .grid-row4-margin-nowrap, .grid-row23-margin-nowrap, .grid-row34-margin-nowrap{
			margin: 15px;
			width: calc(100% - 30px);
		}
		.grid-row1-padding-nowrap, .grid-row2-padding-nowrap, .grid-row3-padding-nowrap, .grid-row4-padding-nowrap, .grid-row23-padding-nowrap, .grid-row34-padding-nowrap{
			padding: 15px;
			width: calc(100% - 30px);
		}
	}
</style>
